import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

const CARD_COLUMNS_DESKTOP = 4;
const CARD_COLUMNS_TABLET = 2;
const LARGE_TABLET_BREAKPOINT = `(max-width: ${designTokens.breakpoint.xl})`;
const MOBILE_BREAKPOINT = `(max-width: ${designTokens.breakpoint.md})`;
const BUTTON_HEIGHT = designTokens.controlHeight.sm;
const DESCRIPTION_LINE_HEIGHT = 1.45;

export const useVaultWorkflowCardsStyles = makeStyles({
  section: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
  },
  heading: {
    margin: 0,
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },
  grid: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
    display: "grid",
    gridTemplateColumns: `repeat(${CARD_COLUMNS_DESKTOP}, minmax(0, 1fr))`,
    gap: designTokens.spacing[3],
    [`@media ${LARGE_TABLET_BREAKPOINT}`]: {
      gridTemplateColumns: `repeat(${CARD_COLUMNS_TABLET}, minmax(0, 1fr))`,
    },
    [`@media ${MOBILE_BREAKPOINT}`]: {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  card: {
    minWidth: 0,
    overflow: "hidden",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[4]}`,
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: projectIqTokens.shadowSm,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    color: projectIqTokens.teal,
    fontSize: designTokens.fontSize.base,
  },
  cardTitle: {
    margin: 0,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },
  description: {
    margin: 0,
    flex: 1,
    fontSize: designTokens.fontSize.xs,
    lineHeight: DESCRIPTION_LINE_HEIGHT,
    color: projectIqTokens.muted,
  },
  button: {
    alignSelf: "flex-start",
    height: BUTTON_HEIGHT,
    padding: `0 ${designTokens.spacing[3]}`,
    marginTop: designTokens.spacing[1],
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.tealLine}`,
    borderRadius: designTokens.borderRadius.md,
    color: projectIqTokens.ink2,
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    cursor: "pointer",
    transition: `background-color ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: projectIqTokens.tealSoft,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },
});
